import { journeyAction, } from './base';

import { JourneyActionVoiceAnswer as JourneyActionVoiceAnswerBase, } from 'atlas-shared';

export const JourneyActionVoiceAnswer = journeyAction({
  ...JourneyActionVoiceAnswerBase,
  icon: 'Voice',
});
